<template>
  <div class="home">
    <main class="hero">
      <img src="/logo.jpg" alt="WHY Technologies" class="logo" />
      <h1 class="headline">Software for professional-services firms.</h1>
      <p class="lede">
        WHY Technologies builds and operates the systems that run legal service
        businesses in the United States.
      </p>
      <div class="links" role="navigation" aria-label="Primary">
        <router-link to="/products">Work</router-link>
        <router-link to="/about">About</router-link>
        <a href="mailto:sae@whyt.io">Contact</a>
      </div>
    </main>

    <footer class="footer">
      <span>WHY Technologies Inc.</span>
      <span>Bethesda, Maryland</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<style scoped>
.home {
  --ink: #1e2126;
  --muted: #5c6066;
  --rule: #e6e7e9;
  --accent: #1f3a5f;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  color: var(--ink);
  font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.hero {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10vh 24px 8vh;
}

.logo {
  width: 260px;
  max-width: 64vw;
  height: auto;
  margin-bottom: 56px;
}

.headline {
  font-size: clamp(2rem, 4.2vw, 3.4rem);
  font-weight: 400;
  letter-spacing: -0.025em;
  line-height: 1.1;
  margin: 0 0 24px;
  max-width: 26ch;
}

.lede {
  font-size: 1.125rem;
  line-height: 1.6;
  color: var(--muted);
  max-width: 50ch;
  margin: 0 0 48px;
}

.links {
  display: flex;
  gap: 32px;
  justify-content: center;
  width: auto;
  position: static;
}

.links a {
  color: var(--ink);
  text-decoration: none;
  font-size: 1rem;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--rule);
  transition: border-color 0.15s ease;
}

.links a:hover,
.links a:focus-visible {
  border-color: var(--ink);
  outline: none;
}

.footer {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: 28px 24px;
  border-top: 1px solid var(--rule);
  font-size: 0.875rem;
  color: var(--muted);
}

@media (max-width: 600px) {
  .logo {
    margin-bottom: 40px;
  }
  .links {
    gap: 24px;
  }
  .footer {
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }
}
</style>